<!--
 * @Author: Merlin
 * @Date: 2024-10-11 10:51:03
 * @LastEditors: Merlin
 * @LastEditTime: 2024-11-14 11:38:10
 * @Description: 
-->
<template>
    <section class="fees-block" >
        <div class="fees-block__heading">
            <div class="radio-group fees-block__radios" style="--7ff506d0: 16px; --33b652e0: 8px;">
                <div class="radio-btn"
                    @click="setTypeValue(oPnlFlat.pnl)" 
                >
                    <input
                        :id="aID[0]"
                        :name="aID[0]"
                        type="radio"
                        checked
                        class="radio-btn__input"
                        :value="oPnlFlat.pnl" 
                        v-model="sFeeType"
                        :class="{ 'radio-btn__input--checked': isPnl }"
                    >
                    <div class="v-popper v-popper--theme-menu v-popper--theme-dropdown tooltip radio-btn__tooltip"
                        customclass="radio-btn__tooltip" iconsize="22" showicon="true" iconcolor="#55657e"
                    >
                        <label class="radio-btn__label" :for="aID[0]">
                            {{ $t('waves.PnLFee') }}
                        </label>
                    </div>
                </div>
                <!-- 左右分界 -->
                <div class="radio-btn"
                    @click="setTypeValue(oPnlFlat.flat)" 
                >
                    <input
                        :id="aID[1]"
                        :name="aID[1]"
                        type="radio"
                        :value="oPnlFlat.flat" 
                        v-model="sFeeType"
                        class="radio-btn__input"
                        :class="{ 'radio-btn__input--checked': !isPnl }"
                    >
                    <div class="v-popper v-popper--theme-menu v-popper--theme-dropdown tooltip radio-btn__tooltip"
                        customclass="radio-btn__tooltip" iconsize="22" showicon="true" iconcolor="#55657e"
                    >
                        <label class="radio-btn__label" :for="aID[1]">
                            {{ $t('waves.FlatFee') }} 
                        </label>
                    </div>
                </div>
            </div>
            <!-- ↓ 提示按钮 -->
            <div class="fees-block__tooltip-wrap">
                <ClientOnly>
                    <Popper
                        :style="oPopperStyle"
                        :hover="true"
                        :arrow="true"
                        :offsetDistance="'3px'"
                        placement="top"
                    >
                        <IconSvgUse
                            use="icon-question"
                            class="w-[16px] h-[16px]"
                            color="#55657e"
                        />
                        <template #content>
                            <div class="popper-content"> 
                                {{ $t('waves.YouDontPayAnyFeesTo') }}
                            </div>
                        </template>
                    </Popper>
                </ClientOnly>
            </div>
        </div>
        <!-- ↑ 选择计费方式 -->
        <!-- ↓ 最后几行提示 -->
        <!-- ↓ 提示，2显1 -->
        <div class="fees-block__desc">
            <template v-if="isPnl"> 
                {{ $t('waves.PnLFeeTips') }}
            </template>
            <template v-else>
                {{ $t('waves.FlatFeeTips', oTipsInfo) }}
            </template>
        </div>
        <!-- ↓最后一行，暂无折扣，先关闭 --> 
        <div class="fees-block__bottom"
            v-if="0"
        >
            <div>
                {{ $t('waves.BFGDiscount') }}:
                <span>{{ $t('waves.SaveUpTo') }} 60%</span>
                &nbsp;
            </div>
            <ClientOnly>
                <Popper
                    :style="oPopperStyle"
                    :hover="true"
                    :arrow="true"
                    placement="top"
                >
                    <IconSvgUse
                        use="icon-question"
                        class="w-[16px] h-[16px]"
                        color="#55657e"
                    />
                    <template #content>
                        <div class="popper-content">
                            {{ $t('waves.DiscountTips') }} 
                            <p class="discount-rate"
                                v-for="(cur, idx) of aDisCountMap" :key="idx"
                            >
                                {{cur}}
                            </p>
                        </div>
                    </template>
                </Popper>
            </ClientOnly>
        </div>
    </section>
</template>

<script setup lang="ts">
import Popper from "vue3-popper"; 
import {
    oWavesBetForm_a,
    fnSettingCenter_Ft, 
    chartState_r,
} from '@/pages/casino/futuresGame/ts/wavesControlCenter';
import {
    oPnlFlat,
    aDisCountMap,
} from '../ts/wavesData'; 
import { 
    fnGetCoeff,
} from '../ts/wavesFn'; 

const props = defineProps({
    mark: {
        type: String as PropType<"calculator">,
    },
    occasion: String, 
    pair: String, // 目标币种，计算器窗口专用 
    modelValue: { // feeType 
        type: String as PropType<oPnlFlat>, 
    },
    totalPosition: {
        type: Number,
        default: 1,
    },
    coeff: {
        type: Number,
        default: 0,
    },
});

const oSettingCenter = fnSettingCenter_Ft();
const emit = defineEmits(['update:modelValue']);

// --- ↑ 一般声明 -------------------- 
// --- ↓ 计算值声明  -------------------- 

const isInCalculator = computed(() => {
    return props.mark === 'calculator';
});

const finalPair = computed(()=>{
    if (isInCalculator.value){
        return props.pair;
    }
    return chartState_r.selectedPair;
});

const aID = computed(() => {
    let sTailMark = '_panel'; 
    if (isInCalculator.value){
        sTailMark = '_calc';
    }
    const aResult = [
        'fee_options0' + sTailMark,
        'fee_options1' + sTailMark,
    ];
    return aResult;
});


const sFeeType = computed({
    get(){
        if (isInCalculator.value){ 
            return props.modelValue;
        }
        return oWavesBetForm_a.feeType; 
    },
    set(sNew){
        if (isInCalculator.value){ 
            emit('update:modelValue', sNew);
        }else{
            oWavesBetForm_a.feeType = sNew; 
        }
    },
});

const isPnl = computed(()=>{
    // return true;
    return sFeeType.value === oPnlFlat.pnl;
});

// ↓ 主要用于 flat 计费模式的提示  
const oTipsInfo = computed(()=>{
    const oResult = {
        percent: null,
        // ↓ 原版采用全舍不入方式处理小数：0.24 * 11 = 2.639999999999999 页面显示为 2.63 
        position: null,
    };
    if (isInCalculator.value){
        oResult.percent = props.coeff;
        oResult.position = props.totalPosition;
    }else{
        const amount = oWavesBetForm_a.wager * oWavesBetForm_a.multi; 
        oResult.position = amount; 
        oResult.percent = fnGetCoeff({ 
            amount, 
            coeffRates: oSettingCenter.currentPairCoeffValues?.value,
            // currency: '', // 使用默认值（当前付款币种） 
        });
    }
    const iDecimalPlaces = oSettingCenter.fnGetTheiDecimalPlaces(
        finalPair.value, // 当前虚拟币 
    );
    const sPosition = number2LocaleString(oResult.position, {
        minimumFractionDigits: 2,
        maximumFractionDigits: iDecimalPlaces,
    });
    oResult.percent = (oResult.percent * 100).toFixed(3); 
    oResult.position = sPosition; 
    return oResult;
});


const setTypeValue = (newVal:oPnlFlat)=>{
    sFeeType.value = newVal;
}



</script>

<style scoped lang="scss">

.radio-group {
    justify-content: space-between;
    width: 100%
}

.radio-btn,.radio-group {
    align-items: center;
    display: flex
}

.radio-btn__input {
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    background-color: transparent;
    border: 2px solid var(--Background-Tertiary);
    border-radius: 50%;
    cursor: pointer;
    display: grid;
    height: var(--7ff506d0);
    margin: 0 6px 0 0;
    place-content: center;
    width: var(--7ff506d0);
    transform: scale(1.0); // 防止在窗口中变形， 
}

.radio-btn__input:before {
    background: var(--color_blue);
    border-radius: 50%;
    box-shadow: none;
    content: "";
    height: var(--33b652e0);
    transform: scale(0);
    transition: transform .12s ease-in-out;
    width: var(--33b652e0)
}

.radio-btn__input--checked:before {
    transform: scale(1)
}

.radio-btn__label {
    color: var(--color_white);
    cursor: pointer;
    font-size: 12px;
    font-weight: 600;
    letter-spacing: -.02em;
    line-height: 16px;
    margin-bottom: 0;
    margin-top: 0
}

.radio-btn--reverse {
    flex-direction: row-reverse
}

.radio-btn--reverse .radio-btn__input {
    margin: 0 0 0 6px
}

.radio-btn--disabled .radio-btn__input {
    border-color: var(--Background-Quinary);
    cursor: default
}

.radio-btn--disabled .radio-btn__input:before {
    background: var(--Background-Quaternary)
}

.radio-btn--disabled .radio-btn__label {
    color: var(--Background-Quaternary);
    cursor: default
}


// ===================
// ===================
// ===================


.fees-block {
    grid-area: fees
}

.fees-block .content-wrapper {
    font-size: 12px;
    font-weight: 600;
    letter-spacing: -.02em;
    line-height: 16px;
    margin-bottom: 0;
    margin-top: 0
}

.fees-block .fees-block__radios {
    grid-area: radios;
}

// @media (max-width: 639px) {
//     .fees-block .fees-block__radios .radio-btn:last-child {
//         left:50%;
//         position: absolute
//     }
// }

// @media (max-width: 871px) {
//     .opened-left-panel .fees-block .fees-block__radios .radio-btn:last-child {
//         left:50%;
//         position: absolute
//     }
// }

// @media (max-width: 964px) {
//     .opened-right-panel .fees-block .fees-block__radios .radio-btn:last-child {
//         left:50%;
//         position: absolute
//     }
// }

// @media (max-width: 979px) {
//     .opened-contests-panel .fees-block .fees-block__radios .radio-btn:last-child {
//         left:50%;
//         position: absolute
//     }
// }

// @media (max-width: 1196px) {
//     .opened-left-panel.opened-right-panel .fees-block .fees-block__radios .radio-btn:last-child {
//         left:50%;
//         position: absolute
//     }
// }

// @media (max-width: 1211px) {
//     .opened-left-panel.opened-contests-panel .fees-block .fees-block__radios .radio-btn:last-child {
//         left:50%;
//         position: absolute
//     }
// }


.fees-block .fees-block__tooltip-wrap {
    display: flex;
    justify-content: flex-end;
    width: 30%
}

.fees-block__heading {
    align-items: center;
    display: flex;
}

.fees-block__tooltip--disabled {
    opacity: .32
}

.fees-block__tooltip-link {
    cursor: pointer;
    text-decoration: underline
}

.fees-block__desc {
    color: var(--Background-Tertiary);
    font-size: 11px;
    font-weight: 600;
    letter-spacing: -.02em;
    line-height: 14px;
    margin-bottom: 0;
    margin-top: 0;
    padding: 8px 0
}

.fees-block__desc--disabled {
    opacity: .32
}

.fees-block__bottom {
    align-items: center;
    color: var(--Background-Tertiary);
    display: flex;
    font-size: 11px;
    font-weight: 600;
    letter-spacing: -.02em;
    line-height: 14px;
    margin-bottom: 0;
    margin-top: 0
}

.fees-block__bottom span {
    color: var(--color_green)
}

.fees-block__bottom--disabled {
    opacity: .32
}

.fees-block__waves {
    align-items: center;
    color: var(--Background-Tertiary);
    display: flex;
    font-size: 12px;
    font-weight: 600;
    justify-content: center;
    letter-spacing: -.02em;
    line-height: 16px;
    margin-bottom: 0;
    margin-top: 0;
    min-height: 24px
}

.fees-block__waves span {
    color: var(--color_green);
    margin-right: 4px
}

.fees-block__waves--disabled {
    opacity: .3
}

.fees-block__tooltip-link {
    cursor: pointer;
    text-decoration: underline
}

// =========================

.popper-content{
    display: block;
    width: 200px;
    color: var(--color_grey-20); 
    font-size: 12px;
    font-weight: 500;
    line-height: 18px;
}


</style>

